import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import ModalComponent from 'components/Modal';

// body đã được BE render placeholder + lọc HTMLPurifier nên hiển thị trực tiếp
const MailPreviewModal = ({ isShowModal, setShowModal, preview }) => {
  const { t } = useTranslation();

  return (
    <ModalComponent
      toggle={() => setShowModal(false)}
      isShowModal={isShowModal}
      title={t('candidateMail.preview')}
      classNameAdd={styles.modalPreview}
    >
      <div className={styles.previewMeta}>
        <p>
          <b>{t('candidateMail.to')}:</b> {preview?.to_email || t('candidateMail.noEmail')}
        </p>
        {preview?.cc && (
          <p>
            <b>CC:</b> {preview.cc}
          </p>
        )}
        {preview?.bcc && (
          <p>
            <b>BCC:</b> {preview.bcc}
          </p>
        )}
        {preview?.reply_to && (
          <p>
            <b>Reply-To:</b> {preview.reply_to}
          </p>
        )}
        <p>
          <b>{t('managerMailTemplate.subject')}:</b> {preview?.subject}
        </p>
      </div>
      <div className={styles.previewBody} dangerouslySetInnerHTML={{ __html: preview?.body || '' }} />
    </ModalComponent>
  );
};

export default MailPreviewModal;
